/*
 * @Author: Gaho
 * @Date: 2023-12-18 14:51:29
 * @LastEditors: Gaho
 * @LastEditTime: 2024-01-25 14:39:47
 */
import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
export const usePlinko = (rootPath='games') => {
    const EMIT_PLINKO_BET = (data: any, callback: Function) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return asyncEmit<{
            response
        }>( `${rootPath}.plinko.bet`, data);
    };

    return {
        EMIT_PLINKO_BET,
    };
};
